import React, { useEffect, useState } from "react";
import { DialogTitle, Drawer } from "@mui/material";
import { getNodeFormFields } from "../../../utils/workflow/getNodeFormFields";
import NodesDynamicForm from "../../../forms/NodesDynamicForm";
import { useParams } from "react-router-dom";
import useAutomations from "../../../hooks/automationhooks/useAutomations";
import SMSSideMenu from "./SMSSideMenu";
import WhatsappSideMenu from "./WhatsappSideMenu";
import nodeTypesConfig from "../../../models/nodeTypesConfig";
import { useThemeContext } from "../../../Theme/Theme";
import EmailSideMenu from "./EmailSideMenu";
import CRMSideMenu from "./CRMSideMenu";

function NodeSideMenu({ open, selectedNode, onSave, onCancel, setMenu }) {
  const [formFields, setFormFields] = useState([]);
  const {
    brandSegments,
    whatsappNumbers,
    emails,
    campaigns,
    handleGetEmails,
    handleGetCampaigns,
    handleGetBrandSegments,
    handleGetWhatsappNumbers,
  } = useAutomations();
  const { automationId, brandId } = useParams();

  useEffect(() => {
    if (open && selectedNode) {
      setFormFields([]);
      const type = selectedNode.type;
      const fields = getNodeFormFields(
        type,
        nodeTypesConfig,
        brandSegments,
        campaigns,
        whatsappNumbers
      );
      setFormFields(fields || []);
    }
  }, [open, selectedNode, brandSegments, campaigns]);

  useEffect(() => {
    const currentBrandId = brandId || localStorage.getItem("brandId");
    if (currentBrandId) {
      handleGetCampaigns(currentBrandId);
    }
  }, [brandId]);

  useEffect(() => {
    const currentBrandId = brandId || localStorage.getItem("brandId");
    if (currentBrandId) {
      handleGetBrandSegments(currentBrandId);
    }
  }, [brandId]);

  useEffect(() => {
    const currentBrandId = brandId || localStorage.getItem("brandId");
    if (currentBrandId) {
      handleGetWhatsappNumbers(currentBrandId);
    }
  }, [brandId]);

  const handleSubmit = (value) => {
    switch (selectedNode.type) {
      case "smsMessage":
        if (value) {
          selectedNode.data.template.value = value.Id;
          selectedNode.data.template.label = value.TemplateName;
        }
        break;
      case "whatsappMessage":
        if (value) {
          selectedNode.data.template.value = value.TemplateId;
          selectedNode.data.template.label = value.TemplateName;
          selectedNode.data.template.previewText = value.MessageText;
        }
      case "emailMessage":
        if (value) {
          selectedNode.data.id = value.id;
          selectedNode.data.name = value.name;
        }
      case "sendToCrm":
        if (value) {
          selectedNode.data.id = value.id;
          selectedNode.data.name = value.name;
        }
        break;
    }
  };

  let initialData = {};
  if (selectedNode?.data) {
    initialData = structuredClone(selectedNode.data);
  }

  function stripValueLabel(obj) {
    const out = { ...obj };

    Object.entries(out).forEach(([key, val]) => {
      // Skip processing if this field is a conditionBuilder or pipeBuilder array
      const field = formFields.find((f) => f.id === key);
      if (
        field &&
        (field.type === "conditionBuilder" ||
          field.type === "pipeBuilder" ||
          field.type === "pipeBuilderTrigger")
      ) {
        // Keep the original array structure for condition and pipe builders
        return;
      }

      // Also check for common pipe/condition field names if formFields isn't ready yet
      if (
        ["conditions", "pipes", "pipeConditions", "queryConditions"].includes(
          key
        )
      ) {
        return;
      }

      if (Array.isArray(val) && val.length && val[0]?.value !== undefined) {
        out[key] = val.map((item) => item.value);
      } else if (val && typeof val === "object" && val.value !== undefined) {
        out[key] = val.value;
      }
    });

    return out;
  }

  // Always apply stripValueLabel, but it will preserve conditionBuilder and pipeBuilder fields
  if (formFields.length > 0) {
    initialData = stripValueLabel(initialData);
  }

  console.log("Initial data for", selectedNode?.type, ":", initialData);

  if (!selectedNode) return null;

  const renderNodeMenu = () => {
    switch (selectedNode.type) {
      case "smsMessage":
        return (
          <SMSSideMenu
            onClose={onCancel}
            onSubmit={handleSubmit}
            selectedNode={selectedNode}
          />
        );
      case "whatsappMessage":
        return (
          <WhatsappSideMenu
            onClose={onCancel}
            onSubmit={handleSubmit}
            selectedNode={selectedNode}
          />
        );
      case "emailMessage":
        return (
          <EmailSideMenu
            onClose={onCancel}
            onSubmit={handleSubmit}
            selectedNode={selectedNode}
          />
        );
      case "sendToCrm":
        return (
          <CRMSideMenu
            onClose={onCancel}
            onSubmit={handleSubmit}
            selectedNode={selectedNode}
          />
        );
      // case "conditionNode":
      //     console.log(selectedNode);
      //     return <ConditionSideMenu onClose={onCancel} onSubmit={handleSubmit} selectedNode={selectedNode} />
      default:
        return (
          <>
            <NodesDynamicForm
              title={`Edit ${selectedNode.data.label} Node`}
              formFields={formFields}
              initialData={initialData}
              onSubmit={(formData) => {
                console.log("=== NodeSideMenu received formData ===", formData);
                onSave(formData);
                onCancel();
              }}
              onClose={onCancel}
            />
          </>
        );
    }
  };

  return (
    <Drawer
      open={open}
      onClose={onCancel}
      PaperProps={{
        sx: {
          position: "fixed",
          right: 0,
          top: 0,
          height: "100%",
          margin: 0,
          maxWidth: "1500px",
          width: "1500px",
          borderRadius: 0,
        },
      }}
    >
      {renderNodeMenu()}
    </Drawer>
  );
}

export default NodeSideMenu;
